import { PHASES, PHASE_LABELS, type Phase } from "../../gait/phases";

const ENDS: Record<Phase, number> = {
  IC: 0.02,
  LR: 0.12,
  MSt: 0.31,
  TSt: 0.5,
  PSw: 0.62,
  ISw: 0.75,
  MSw: 0.87,
  TSw: 1.0,
};

/** Rancho Los Amigos 8-phase strip with stance/swing split. */
export function PhaseStrip() {
  let prev = 0;
  const segs = PHASES.map((p) => {
    const w = (ENDS[p] - prev) * 100;
    const stance = ENDS[p] <= 0.62 + 1e-6;
    prev = ENDS[p];
    return { p, w, stance };
  });

  return (
    <div className="card">
      <div className="row" style={{ justifyContent: "space-between" }}>
        <strong>Gait cycle</strong>
        <span className="muted">Rancho Los Amigos · stance 0–62% · swing 62–100%</span>
      </div>
      <div style={{ display: "flex", gap: 3, marginTop: 14, height: 40 }}>
        {segs.map((s, i) => (
          <div
            key={i}
            title={PHASE_LABELS[s.p]}
            style={{
              flex: `${Math.max(s.w, 3)} 0 0`,
              minWidth: 22,
              borderRadius: 8,
              display: "grid",
              placeItems: "center",
              fontSize: 11,
              fontWeight: 700,
              color: s.stance ? "#00121f" : "#04211c",
              background: s.stance
                ? "linear-gradient(135deg, #7cc4ff, #4f9eff)"
                : "linear-gradient(135deg, #5eead4, #34d399)",
              boxShadow: "0 4px 14px rgba(10,132,255,0.18)",
            }}
          >
            {s.p}
          </div>
        ))}
      </div>
      <div className="row" style={{ justifyContent: "space-between", marginTop: 8 }}>
        <span className="muted">Initial contact</span>
        <span className="muted">Toe-off</span>
        <span className="muted">Terminal swing</span>
      </div>
    </div>
  );
}
